const confirmButton = document.querySelector('.popup-confirmation-button');
const customizeAnotherButton = document.querySelector('.popup-another');

const cartLinkButton = document.querySelector('.flask-checkout-link');
const proceedFlaskButton = document.querySelector('.proceed-flask');
const popupUpsell = document.querySelector('#popup-upsell');
let flaskGiftNote = "";

cartLinkButton.addEventListener('click', (e) =>{
  e.preventDefault();
});

confirmButton.addEventListener('click', async (e) => {
  location.href = '/cart';
});
proceedFlaskButton.addEventListener('click', async (e) => {
  await checkout('proceed');
});
customizeAnotherButton.addEventListener('click', async (e) => {
  document.querySelector('.flask-customization-main').classList.remove('loading-icon');
  document.querySelector('.preview-popup .popup-wrapper').classList.remove('loading-icon');
  document.querySelector('.preview-popup').classList.remove('show', 'slide-in');

  if (typeof goToBottleComponent === 'function') {
    goToBottleComponent();
  }
});

popupUpsell.addEventListener('click', async (e) => {
  e.preventDefault();
  await checkout('confirm');
  location.href = '/collections/sunnies-flask';
});



let formData = {
 'items': []
};

function addParent(id, bundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': bundleID
        }
    });
}

function addBottleComponent(id, bundleID, engravingID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': bundleID,
          '_bottleEngravingID': engravingID,
          '_order_url': window.location.href
        }
    });
}
function addCapComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addLoopComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addBootComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addEngravingComponent(id, parentBundleID, engravingID, engravingText, item_type, engravingPlacement, engravingColor, engravingOrientation = 'Horizontal', engravingFont) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID,
          '_isBundleComponent': true,
          '_bottleEngravingID': engravingID,
          '_engravingPlacement': engravingPlacement,
          '_engravingOrientation': engravingOrientation,
          '_engravingColor': engravingColor,
          '_engravingFontFamily': engravingFont,
          'Engraving': engravingText
        }
    });
}
function addGliderComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
    console.log('formData', formData)
}

function alertThenReload(message) {
  window.alert(message);
  window.location.reload();
}

async function checkout(method){
  
  customizationMain.classList.add('loading-icon');
  
  document.querySelector('.preview-popup .popup-wrapper').classList.add('loading-icon');
  let bundleID = Date.now() + Math.floor(Math.random()*(100-1+1)+1);
  let bottleEngravingID = 'Bottle_' + bundleID;


  if(bottleBundleVariantID.length > 1 && capBundleVariantID.length > 1 && loopBundleVariantID.length){
    getCapType() == 'robo' ? gliderActive ? addGliderComponent('43464066793526', bundleID, 'flask_bundle') : addGliderComponent('43815653670966', bundleID, 'flask_bundle') : '';
    if (!document.querySelector('.flask-customization-main').classList.contains('no_engraving')){
      engravingValue.length > 1 ? addEngravingComponent('41920481165366', bundleID, bottleEngravingID, engravingValue, 'flask_bundle', engravingPlacement, engravingColor, engravingOrientation, engravingFont) : '';
    }
    (bootVariantID.length > 1 && bottleSizeOption != '64oz') && (bootVariantID.length > 1 && bottleSizeOption != '40oz') ? addBootComponent(bootVariantID, bundleID, 'flask_bundle') : '';
    addLoopComponent(loopBundleVariantID, bundleID, 'flask_bundle');
    addCapComponent(capBundleVariantID, bundleID, 'flask_bundle');
    addBottleComponent(bottleBundleVariantID, bundleID, bottleEngravingID, 'flask_bundle');
    
  }
  else{
    bottleBundleVariantID.length > 1 ? addBottleComponent(bottleIndividualVariantID, '', bottleEngravingID, 'flask') : '';
    capBundleVariantID.length > 1 ? addCapComponent(capIndividualVariantID, '', 'flask') : '';
    loopBundleVariantID.length > 1 ? addLoopComponent(loopIndividualVariantID, '', 'flask') : '';
    (bootVariantID.length > 1 && bottleSizeOption != '64oz') && (bootVariantID.length > 1 && bottleSizeOption != '40oz') ? addBootComponent(bootVariantID, bundleID, 'flask') : '';
    if (bottleSizeOption != '30oz') engravingValue.length > 1 ? addEngravingComponent('41920481165366', '', bottleEngravingID, engravingValue, 'flask', engravingPlacement, engravingColor, engravingOrientation, engravingFont) : '';
  }
  

  if(flaskGiftNote.length > 0){
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: flaskGiftNote
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log('Cart updated:', cart);
      })
      .catch((error) => {
        console.error('Error updating cart note:', error);
      });
    
  }
  let cartResponse;
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(data => {
      cartResponse = data;
      return data;
    });
    
  })
  .then(data => {
    console.log('data', data);
    if(data.status == "too_many_requests" || data.status == 429){
      document.querySelector('.flask-customization-main').classList.remove('loading-icon');
      document.querySelector('.preview-popup .popup-wrapper').classList.remove('loading-icon');
      alertThenReload('You have reached the maximum number of requests. Please try again later.');
      return;
    }
    popupCheckout.classList.add('show');
    setTimeout(() => {
      document.querySelector('.flask-customization-main').classList.remove('loading-icon');
      document.querySelector('.preview-popup .popup-wrapper').classList.remove('loading-icon');
      popupCheckout.classList.add('slide-in');
    }, 300);

    if(data.status == 422){
      console.log('data', data);
      const overLimitComponent = data.description;
      if(overLimitComponent.includes('Cap')){
        capIsAvailable = false;
      }
      if(overLimitComponent.includes('Boot')){
        bootIsAvailable = false;
      }
      if(overLimitComponent.includes('Bottle')){
        bottleIsAvailable = false;
      }
      if(overLimitComponent.includes('Loop')){
        loopIsAvailable = false;
      }
      
      checkoutOOS(true);

    }
  })
  .catch((error) => {
    console.error('Error:', error);
    
  });

  // if(gliderActive){

  //   await removeStraw();
  //   console.log('gliderActive', gliderActive);
  // }
  return cartResponse.status;
}

async function removeStraw() {
  // First, get the current cart
  return fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((cart) => {
      // Find the straw item in the cart
      const strawItem = cart.items.find(item => item.id === 43815653670966);
      
      if (strawItem) {
        const currentQuantity = strawItem.quantity;
        const newQuantity = Math.max(0, currentQuantity - 1); // Ensure quantity doesn't go below 0
        
        // Update the cart with the new quantity using the key
        const updateData = {
          id: strawItem.key, // Use the key instead of the variant ID
          quantity: newQuantity,
        };

        return fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });
      } else {
        console.log("Straw not found in cart");
        return Promise.resolve();
      }
    })
    .then((res) => {
      if (res && res.status === 200) {
        console.log("Straw quantity updated successfully");
      }
    })
    .catch((err) => console.error("Error updating straw quantity:", err));
}

const oosModal = document.querySelector('.oos-section');
let overLimitStock = false;
// bottleIsAvailable && !bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid
function checkoutOOS(overlimit = false, sizetransition = false){

  addToBag.classList.remove('loading-icon');
  oosModal.style.transform = 'translateY(0)';
    oosModal.classList.add('show');
  
    document.querySelector('#oosc-bottle').innerText = chosenBottle;
    document.querySelector('#oosc-cap').innerText = chosenCap;
    document.querySelector('#oosc-boot').innerText = chosenBoot;
    document.querySelector('#oosc-loop').innerText = chosenLoop;

    if(overlimit){

      if(bootIsAvailable)
        document.querySelector('.oosc--boot').classList.add('hidden')
      else
      document.querySelector('.oosc--boot').classList.remove('hidden')
      
      if(bottleIsAvailable)
        document.querySelector('.oosc--bottle').classList.add('hidden')
      else
      document.querySelector('.oosc--bottle').classList.remove('hidden')

      if(loopIsAvailable)
        document.querySelector('.oosc--loop').classList.add('hidden')
      else
        document.querySelector('.oosc--loop').classList.remove('hidden')

      if(capIsAvailable)
        document.querySelector('.oosc--cap').classList.add('hidden')
      else
        document.querySelector('.oosc--cap').classList.remove('hidden')

      document.querySelector('.oos_title').innerText = 'You have reached the maximum quantity for the following items';
      document.querySelector('.oos_subcopy').innerText = '';
      document.querySelector('#edit-oos-flask').innerText = 'Select another color';
      overLimitStock = true;
    }
    else{

      if(sizetransition){
        if(loopIsAvailable)
          document.querySelector('.oosc--loop').classList.add('hidden')
        if(capIsAvailable)
          document.querySelector('.oosc--cap').classList.add('hidden')
      }
      else{
        if(bootIsAvailable)
          document.querySelector('.oosc--boot').classList.remove('hidden')
        if(bottleIsAvailable)
          document.querySelector('.oosc--bottle').classList.remove('hidden')
        if(loopIsAvailable)
          document.querySelector('.oosc--loop').classList.remove('hidden')
        if(capIsAvailable)
          document.querySelector('.oosc--cap').classList.remove('hidden')
      }
        document.querySelector('.oos_title').innerText = 'Some components are not available.';
        document.querySelector('.oos_subcopy').innerText = 'Select another color to proceed.';
        document.querySelector('#edit-oos-flask').innerText = 'Edit your flask';
        overLimitStock = false;
    }

      if(withBoot){

        document.querySelector('.oos_component.oosc--boot').style.display = 'flex';
      }else{
        document.querySelector('.oos_component.oosc--boot').style.display = 'none';
      }

    document.querySelectorAll('.oos_component').forEach((component) => {
      component.classList.remove('unavailable');
    });

    if (!bootIsAvailable){
      removeSectionActive('boot');
    }
    if (!loopIsAvailable){
      removeSectionActive('loop');
    }
    if (!capIsAvailable){
      removeSectionActive('cap');
    }
    if (!bottleIsAvailable){
      
      removeSectionActive('bottle');
    }
    // customizationMain.scrollTop = +99999;
  }

document.querySelector('#edit-oos-flask').addEventListener('click', (e) => {

  // if(overLimitStock){
  //   location.href = '/cart';
  // }
  // else{  
  addToBag.classList.remove('disabled');
  addToBag.classList.remove('loading-icon');
  updateCTA();
  
    oosModal.classList.remove('show');
    setTimeout(() => {
      oosModal.style.transform = 'translateY(100%)';
    }, 400);
  // }
});
// preview-components
function removeSectionActive(tab){
  
  document.querySelector(`.oos_component.oosc--${tab}`).classList.add('unavailable');

  if(window.innerWidth < 900){
    document.querySelector(`input#${tab}-tab`).click();
  }
}